import React, { createContext, useState } from "react";

const PendingRequestsContext = createContext({
    handlePendingRequestsUpdate: () => {},
    handlePendingRequestsCountUpdate: () => {},
    pendingRequestsCount: null,
});

export const PendingRequestsProvider = ({ children }) => {
    const [pendingRequests, setPendingRequests] = useState([]);
    const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
    const handlePendingRequestsUpdate = requestsUpdate => {
        setPendingRequests([...requestsUpdate]);
    };
    const handlePendingRequestsCountUpdate = countUpdate => {
        setPendingRequestsCount(countUpdate);
    };

    return (
        <>
            <PendingRequestsContext.Provider
                value={{
                    pendingRequests,
                    pendingRequestsCount,
                    handlePendingRequestsUpdate,
                    handlePendingRequestsCountUpdate,
                }}
            >
                {children}
            </PendingRequestsContext.Provider>
        </>
    );
};

export default PendingRequestsContext;
